import React from 'react';
import ReactDOM from 'react-dom';
import InterestCalculator from './interest-calculator';

export default function reactInterestCalculator(elementOrId, props = {}) {
  let element;
  if (typeof elementOrId === 'string') {
    element = window.document.getElementById(elementOrId);
  } else {
    element = elementOrId;
  }
  ReactDOM.render(<InterestCalculator { ...props } />, element);
}

window.reactInterestCalculator = window.reactInterestCalculator || reactInterestCalculator;
